import(/* webpackMode: "eager" */ "/var/www/html/src/app/[slug]/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/src/components/webformList/webformList.tsx");
